import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { workbooks } from '../data/content';
export function WorkbooksSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-paper px-5 py-6 sm:py-12" data-id="element-255" data-mp="2uddiizg346hr">
      <div className="mx-auto max-w-5xl" data-id="element-256" data-mp="2ucu1dky9dm4s">
        <div className="mx-auto max-w-2xl text-center" data-id="element-257" data-mp="2qb8pa1tjtbvn">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-258" data-mp="2qcto43mwbgzb">
            5 volumes pédagogiques
          </h2>
          <p className="mt-2 text-sm text-ink/70 sm:mt-3 sm:text-base" data-id="element-259" data-mp="2gct2uc5guqsh">
            60 pages par volume, très visuelles, organisées par notion et prêtes à projeter
          </p>
        </div>

        <div className="mt-6 grid gap-4 sm:mt-10 sm:gap-6 md:grid-cols-2" data-id="element-260" data-mp="emhkanpysrtg">
          {workbooks.map((workbook, i) => {
          const isOpen = openIndex === i;
          return <motion.article key={workbook.number} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.2
          }} transition={{
            duration: 0.3,
            delay: i % 2 * 0.06,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-2xl border border-cobalt/25 bg-white p-4 shadow-sm shadow-cobalt/5 sm:p-6" data-id="element-261" data-mp="1v3xvx4t96k2k" data-mpi={i}>
                <div className="flex gap-4" data-id="element-262" data-mp="2duxr4nrccq4a">
                  <div className="flex min-w-0 flex-1 flex-col" data-id="element-263" data-mp="2isz6oypk67b0">
                    <span className="font-serif-display text-3xl font-bold leading-none text-cobalt sm:text-4xl" data-id="element-264" data-mp="2ivbn37fo49ly">
                      {workbook.number}
                    </span>
                    <h3 className="mt-2 text-sm font-bold leading-snug text-ink sm:mt-3 sm:text-lg" data-id="element-265" data-mp="291uvma3076lg">
                      {workbook.title}
                    </h3>
                    <p className="mt-1 text-[13px] font-medium leading-snug text-cobalt-deep sm:text-sm" data-id="element-266" data-mp="31k061nulc4v3">
                      {workbook.subtitle}
                    </p>
                    <span className="mt-3 inline-block w-fit rounded-full bg-cobalt/10 px-2.5 py-1 text-[11px] font-medium text-cobalt-deep sm:text-xs" data-id="element-267" data-mp="36gmbdm5ziy1k">
                      {workbook.tag}
                    </span>
                    <span className="mt-2 text-[11px] font-medium text-ink/55 sm:text-xs" data-id="element-268" data-mp="2xgh73kw38frm">
                      {workbook.value}
                    </span>
                  </div>
                  <div className="shrink-0 self-start rounded-xl bg-cobalt/10 p-1.5" data-id="element-269" data-mp="2nq4po1jkl2pp">
                    <img src={workbook.coverImage} alt={`Volume ${workbook.number} : ${workbook.title}`} loading="lazy" className="block h-[80px] w-[80px] rounded-lg object-contain sm:h-[120px] sm:w-[120px]" data-id="element-270" data-mp="2nobfic9r00cy" />
                  </div>
                </div>

                <div className="mt-4 border-t border-cobalt/10 pt-3 sm:hidden" data-id="element-271" data-mp="24slaeg6iqnuu">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between text-xs font-bold text-ink/70" data-id="element-272" data-mp="ka14d8v9z6ro">
                    Voir le contenu
                    <ChevronDownIcon className={`h-4 w-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-273" data-mp="y87shxaf9se5" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-274" data-mp="ajok7hrdhfm2">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.25,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-275" data-mp="fa4w2xfjot6b">
                        <p className="pt-3 text-[13px] leading-relaxed text-ink/70" data-id="element-276" data-mp="2zuwgz328otpw">
                          {workbook.description}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>

                <p className="mt-4 hidden text-sm leading-relaxed text-ink/70 sm:block" data-id="element-277" data-mp="34sxwje0giawm">
                  {workbook.description}
                </p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}